import { render, staticRenderFns } from "./VectorConfigDialog.vue?vue&type=template&id=9117c816&scoped=true"
import script from "./VectorConfigDialog.vue?vue&type=script&lang=js"
export * from "./VectorConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./VectorConfigDialog.vue?vue&type=style&index=0&id=9117c816&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9117c816",
  null
  
)

export default component.exports